import React from "react";
import Icone from "./Icone";

const EPAISSEURS = { succes: 2.4, danger: 2.4 };

/**
 * Écran « résultat » centré : pastille (ou rond d'attente), titre, contenu.
 * ton : succes | danger | avert | info | attente.
 */
const EcranResultat = ({ ton = "info", icone = null, titre, children }) => {
  const idTitre = "titre-" + titre.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  return (
    <section className="centre" aria-labelledby={idTitre} data-ton={ton}>
      <div className={`pastille ${ton}`}>
        {ton === "attente" ? (
          <span className="spin" aria-hidden="true" />
        ) : (
          <Icone nom={icone} epaisseur={EPAISSEURS[ton] || 2.2} />
        )}
      </div>
      <h2 id={idTitre}>{titre}</h2>
      {children}
    </section>
  );
};

export default EcranResultat;
